import { render, staticRenderFns } from "./MarketSales.vue?vue&type=template&id=6b05607a&scoped=true"
import script from "./MarketSales.vue?vue&type=script&lang=js"
export * from "./MarketSales.vue?vue&type=script&lang=js"
import style0 from "./MarketSales.vue?vue&type=style&index=0&id=6b05607a&prod&scoped=true&lang=css"
import style1 from "./MarketSales.vue?vue&type=style&index=1&id=6b05607a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b05607a",
  null
  
)

export default component.exports